import controller from './manage-my-rlink-categories.controller'
import template   from './manage-my-rlink-categories.html'
import './manage-my-rlink-categories.styl'

let component = {
  restrict: 'E',
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/categories/manage-my-rlink-categories.component.js